import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

// import ConsultationFloatingWidget from 'src/components/ConsultationFloatingWidget';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const CegahDiabetes = dynamic(() => import('src/containers/CegahDiabetes'));

const CegahDiabetesPage = (props: any) => {
	return (
		<>
			<HeadC
				title="Tes Diabetes Online - Health Tools KlikDokter"
				description={
					'Cek risiko dengan tes diabetes secara online untuk mencegahnya sejak dini. ' +
					'Yuk, gunakan Health Tools Cegah Diabetes di KlikDokter.'
				}
				pageItem={props.imageMenuCategory[0]}
				hideSuffix
			/>
			<CegahDiabetes {...props} />

			{/* <ConsultationFloatingWidget /> */}
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	const menu: any = await store.dispatch(actionGetMenu());
	const menuOptions = menu?.data?.record?.deteksi_menu;
	const filterMenuSelection = menuOptions.filter(
		(item: any) => item.deeplink === '/cegah-diabetes',
	);
	const dataImage = filterMenuSelection?.map((item: any) => item.icon);

	return {
		props: {
			imageMenuCategory: dataImage,
		},
	};
});

export default CegahDiabetesPage;
